<template>
  <b-container fluid class="projects">
    <b-row>
      <b-col style="padding: 0px;">
        <div class="text-center backgroundImg" v-bind:style="{background: 'url(' + getImage(bannerImg, 'banner') +')'}" >
          <div class="title-top text-uppercase">{{projectTitleTop}}</div>
          <div class="title-middle text-uppercase primaryColor">{{projectTitleMid}}</div>
          <center>
            <div class="title-bottom">
              {{projectTitleBot}}
            </div>
          </center>
        </div>
      </b-col>
    </b-row>
    <!-- Project -->
    <b-row class="section1 pt-5 pb-5">
      <b-col class="customized">
        <div class="project" v-for="(project, index) in projectList.data" :key="index">
          <div class="location text-uppercase mb-3">{{project.attributes.city}}</div>
          <img :src="getImage(project.attributes.images.data[0].attributes.url, 'url')">
          <div class="name m-3">{{project.attributes.name}}</div>
          <div class="description">{{project.attributes.desc}}</div>
        </div>
        <div v-if="projectList.length == 0">
          Tidak ada project yang tersedia saat ini
        </div>
      </b-col>
    </b-row>
</b-container>
</template>

<script>
import util from '@/util'
import {mapGetters} from 'vuex'

export default {
  name: 'Projects',
  data () {
    return {
      projectList: [],
      bannerImg: 'dsk-projects-bg.jpg',
      projectSection: 'projects'
    }
  },
  methods: {
    getImage (imageName, section) {
      return util.getImage(imageName, section)
    },
    getProjectList () {
      this.$data.isLoading = true
      this.$store.dispatch('getProjectList', {
        data: {
        },
        success: (res) => {
          this.$data.projectList = res.data
          this.$data.isLoading = false
        },
        fail: () => {
          this.$data.isLoading = false
          this.$data.isError = true
          console.log('failed get project list')
        }
      }).then(() => {
      }).catch(err => {
        console.log('catch in getProjectList ' + err)
      })
    },
    findContentById (id) {
      this.$data.isLoading = true
      this.$store.dispatch('findContentById', {
        data: {
          id: id
        },
        success: () => {
        },
        fail: () => {
          this.toast('Something went wrong. Try again later.', 'error', 'error_outline')
        }
      }).then(() => {
        this.$data.isLoading = false
      }).catch(err => {
        console.error('error: ' + err)
      })
    },
    findAllContents () {
      this.isLoading = true
      this.$store.dispatch('findAllContents', {
        success: (res) => {
        },
        fail: () => {
          this.toast('Could not get contents. Try again later.', 'error', 'error_outline')
        }
      }).then(() => {
        this.isLoading = false
      }).catch(err => {
        console.error('error: ' + err)
      })
    }
  },
  created () {
    this.getProjectList()
    this.findAllContents()
    // this.findContentById('projectTitleTop')
    // this.findContentById('projectTitleMid')
    // this.findContentById('projectTitleBot')
  },
  computed: {
    ...mapGetters([
      'projectTitleTop', 'projectTitleMid', 'projectTitleBot'
    ])
  }
}
</script>

<style scoped>
.backgroundImg {
  background-size: cover !important;
  min-height: 95vh;
  color: #fff;
}
.title-top {
  padding-top: 25vh;
  font-size: 1.2em;
}
.title-middle {
  padding-top: 50px;
  font-size: 2em;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-weight: bolder;
  letter-spacing: 5px;
}
.title-bottom {
  padding: 40px 10px 20px 10px;
  max-width: 950px;
  font-size: 1.2em;
}
.project {
  margin: 10px;
  padding: 20px;
  background-color: #F2F2F2;
  display: inline-block;
}
.customized {
  column-count: 3;
  -webkit-column-width: 30px;
  column-width: 300px;
  -moz-column-width: 300px;
}
.location:after, .location:before {
  content:"\A";
  width:10px;
  height:10px;
  border-radius:50%;
  background: #FF8F00;
  display:inline-block;
  margin:0px 10px;
}
.name {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/Projects.vue